import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoadingController, ToastController } from "ionic-angular";
import { Observable } from "rxjs";
import { ConfigurationService } from "../../../src/providers/configuration/configuration.service";
@Injectable()
export class BereavementService {
  protected apiUrl;
  spinner = null;
  spinnerCounter = 0;

  constructor(
    private http: HttpClient,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    private config: ConfigurationService
  ) {
    this.apiUrl = config.getConfig().bereavementUrl + "/bereaved-management";
  }

  presentSuccessToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 4000,
      position: "below",
      cssClass: "success",
    });

    toast.present();
  }
  presentErrorToast(err: HttpErrorResponse, message: string) {
    if (err && (err as any).code === "REFRESH_TOKEN_FAILED") {
      return;
    }
    message += " ";
    if (err.error instanceof Error) {
      message += "Client error.";
    } else {
      message += " ";
      if (err.status == 401) {
        message += "User not authorized.";
      } else if (err.status >= 500) {
        message += "Server error.";
      } else {
        message += "Communication error.";
      }
    }

    let toast = this.toastCtrl.create({
      message: message,
      duration: 4000,
      position: "below",
      cssClass: "error",
    });

    toast.present();
  }
  public addBereavmentRisk(data: any): Observable<any> {
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    this.increaseSpinnerCount("Saving record...");
    return new Observable((observer) => {
      this.http.post(`${this.apiUrl}/bereavement`, data).subscribe(
        (data) => {
          this.presentSuccessToast("Successfully saved  data.");
          this.decreaseSpinnerCount();
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          this.decreaseSpinnerCount();
          this.presentErrorToast(err, "Failed to add new record");
          observer.error(err);
          observer.complete();
        }
      );
    });
  }
  public updateBereavmentRisk(data: any): Observable<any> {
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    this.increaseSpinnerCount("Saving record...");
    return new Observable((observer) => {
      this.http.put(`${this.apiUrl}/bereavement`, data).subscribe(
        (data) => {
          this.presentSuccessToast("Successfully saved data.");
          this.decreaseSpinnerCount();
          observer.next(data);
          observer.complete();
        },
        (err: HttpErrorResponse) => {
          this.decreaseSpinnerCount();
          this.presentErrorToast(err, "Failed to update record");
          observer.error(err);
          observer.complete();
        }
      );
    });
  }

  public getBereavementList(
    id,
    pageNum,
    pageSize,
    filter?: number
  ): Observable<any> {
    return new Observable((observer) => {
      this.increaseSpinnerCount("loading data...");
      var url = `${this.apiUrl}/bereavement/${id}/pagenum/${pageNum}/size/${pageSize}`;
      if (filter) url += `?contactId=` + filter;
      this.http.get(url).subscribe(
        (data) => {
          observer.next(data);
          this.decreaseSpinnerCount();
        },
        (err) => {
          if (err.status != 404) {
            this.presentErrorToast(err, "Failed to get records.");
          }
          observer.error(err);
          observer.complete();
          this.decreaseSpinnerCount();
        }
      );
    });
  }

  public getBereavementListBasedOnFilter(
    pageNum,
    pageSize,
    date
  ): Observable<any> {
    return new Observable((observer) => {
      this.increaseSpinnerCount("loading data...");
      this.http
        .get(
          `${this.apiUrl}/bereavement/date/${date}/pagenum/${pageNum}/size/${pageSize}`
        )
        .subscribe(
          (data) => {
            observer.next(data);
            this.decreaseSpinnerCount();
          },
          (err) => {
            if (err.status != 404) {
              this.presentErrorToast(err, "Failed to get records.");
            }
            observer.error(err);
            observer.complete();
            this.decreaseSpinnerCount();
          }
        );
    });
  }

  public saveCheckpointData(data: any): Observable<any> {
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    return new Observable((observer) => {
      this.increaseSpinnerCount("loading data...");
      this.http.put(`${this.apiUrl}/checkpoint`, data).subscribe(
        (data) => {
          observer.next(data);
          this.decreaseSpinnerCount();
        },
        (err) => {
          this.presentErrorToast(err, "Failed to update checkpoint data.");
          observer.error(err);
          observer.complete();
          this.decreaseSpinnerCount();
        }
      );
    });
  }

  public getCheckpointData(id): Observable<any> {
    return new Observable((observer) => {
      this.increaseSpinnerCount("loading data...");
      this.http
        .get(`${this.apiUrl}/checkpoint/${id}/pagenum/0/size/99`)
        .subscribe(
          (data) => {
            observer.next(data);
            this.decreaseSpinnerCount();
          },
          (err) => {
            this.presentErrorToast(err, "Failed to get checkpoint data.");
            observer.error(err);
            observer.complete();
            this.decreaseSpinnerCount();
          }
        );
    });
  }

  public deleteRecord(id): Observable<any> {
    return new Observable((observer) => {
      this.increaseSpinnerCount("Deleting record...");
      this.http.delete(`${this.apiUrl}/bereavement/${id}`).subscribe(
        (data) => {
          this.presentSuccessToast("Successfully deleted.");
          observer.next();
          this.decreaseSpinnerCount();
        },
        (err) => {
          this.presentErrorToast(err, "Failed to delete record.");
          observer.error(err);
          observer.complete();
          this.decreaseSpinnerCount();
        }
      );
    });
  }

  increaseSpinnerCount(message: string = "Loading data...") {
    this.spinnerCounter++;
    if (this.spinnerCounter && this.spinner == null) {
      this.spinner = this.loadingCtrl.create({
        content: message,
      });
      this.spinner.present();
    }
  }

  decreaseSpinnerCount() {
    // console.log( "Decreasing spinner count.", this.spinnerCounter );
    this.spinnerCounter--;
    if (this.spinnerCounter <= 0) {
      this.spinner.dismiss();
      this.spinner = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/bereavement-service/bereavement-service.ts